import React from 'react';
import { setPostImage } from '@images/imageUrls';
import styles from './FeedbackBottomToolbar.module.scss';

interface FeedbackBottomToolbarProps {
    onEmojiClick: () => void;
}

const FeedbackBottomToolbar: React.FC<FeedbackBottomToolbarProps> = ({ onEmojiClick }) => (
    <div className={styles.bottomBar}>
        <button type="button" className={styles.emojiBtn} onClick={onEmojiClick} aria-label="表情">
            <img src={setPostImage.emoji} alt="" className={styles.emojiIcon} />
        </button>
    </div>
);

export default FeedbackBottomToolbar;
